import styled from 'styled-components';

export const Container = styled.div<{ $color: string }>`
  .search-match {
    color: ${({ $color }) => $color};
  }
`;
